export default function(http) {
  const methods = ({handleErrors = false} = {}) => {
    return {
      query(method, url, data = {}) {
        return http.request({
          url, method, data,
          handleErrors,
          skipLoading: true
        })
      },
      getPatients({ patientId }) {
        const path = '/patients' + (patientId ? `/${patientId}` : '');
        return this.query('get', path)
      },
      getMonitors({ monitorId }) {
        const path = '/patient_monitors' + (monitorId ? `/${monitorId}` : '');
        return this.query('get', path)
      },
      getEvents({ monitorId, filter }) {
        let path = `/patient_monitors/${monitorId}/events`
        if (filter) {
          path += `?filter=${filter}`
        }
        return this.query('get', path)
      },
      getCharts({ monitorId, chartId }) {
        let path =  `/patient_monitors/${monitorId}/charts`
        if (chartId) {
          path += `?chart_id=${chartId}`
        }
        return this.query('get', path)
      },
      getCameraStatus({ monitorId }) {
        return this.query('get', `/patient_monitors/${monitorId}/camera_status`)
      },
      updateWidget(widgetId, data) {
        return this.query('put', `/patient_grids/${widgetId}`, data)
      }
    }
  }
  return {
    withoutErrorHandling() {
      return methods({ handleErrors: true })
    },
    ...methods()
  }
}
